"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _excluded = ["title", "description", "isTarget"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var conteinerStyle = {
  width: '92px',
  height: '40px',
  color: _userflow["default"].colors.greyLight,
  fontSize: '10px',
  textAlign: 'center'
};
var targetContainerStyle = _objectSpread(_objectSpread({}, conteinerStyle), {}, {
  color: '#17181A',
  fontWeight: 500,
  backgroundColor: '#FEFACF'
});
var titleStyle = {
  fontSize: '18px'
};
var PriceMatrixTitle = function PriceMatrixTitle(_ref) {
  var title = _ref.title,
    description = _ref.description,
    isTarget = _ref.isTarget,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, (0, _extends2["default"])({
    style: isTarget ? targetContainerStyle : conteinerStyle
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    style: titleStyle
  }, title), " ", description);
};
PriceMatrixTitle.defaultProps = {
  isTarget: false
};
PriceMatrixTitle.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  isTarget: _propTypes["default"].bool
};
var _default = exports["default"] = PriceMatrixTitle;